import React from 'react'

import { CircleHelp } from 'lucide-react'
import { Portal } from "@radix-ui/react-portal";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
	TooltipProvider
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface StatsCardProps {
	title: string
	value: any
	description?: string
	icon?: React.ReactNode
	tooltip?: string
	className?: string
	valueStyleOverride?: string
}

export function StatsCard({
	title,
	value,
	description,
	icon,
	className,
	tooltip,
	valueStyleOverride
}: StatsCardProps) {
	return (
		<Card className={cn('overflow-hidden bg-[#C0E6FF]/10 backdrop-blur-md border border-white/20 rounded-lg shadow-lg', className)}>
			<CardHeader className="flex flex-col justify-start space-y-0 p-0 min-w-60">
				<div className='flex flex-row items-center'>
					{icon && (
						<div className="rounded-full p-2 transition-colors">
							{icon}
						</div>
					)}
					<div className='flex-1'>
						<CardTitle className="text-md font-medium">{title}</CardTitle>
					</div>
					{tooltip && <div className='flex flex-col p-2 transition-colors'>
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger>
									<CircleHelp className='h-5 w-5 rounded-full hover:bg-[#4DA2FF]/30' />
								</TooltipTrigger>
								<Portal>
									<TooltipContent className='bg-[#011829]/80 backdrop-blur-md'>
										{tooltip}
									</TooltipContent>
								</Portal>
							</Tooltip>
						</TooltipProvider>
					</div>}
				</div>


				{description && (
					<TooltipProvider>
						<Tooltip>
							<TooltipTrigger asChild>
								<p className="mt-2 cursor-help truncate text-sm text-muted-foreground">
									{description}
								</p>
							</TooltipTrigger>
							<TooltipContent>
								<p className="max-w-xs break-all">{description}</p>
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
				)}
			</CardHeader>
			<CardContent className='p-2'>

				<div className="flex items-baseline space-x-3 justify-start">
					<div className={cn("text-2xl font-bold", valueStyleOverride)}>{value}</div>
				</div>

			</CardContent>
		</Card>
	)
}